import { ShieldCheck, Shield, ShieldAlert, Clock3 } from "lucide-react";

const MAP = {
  verified: { label: "Verified", short: "Verified", Icon: ShieldCheck, cls: "bg-[hsl(var(--gold))]/15 text-[hsl(var(--gold))] border-[hsl(var(--gold))]/40" },
  pending: { label: "Verification Pending", short: "Pending", Icon: Clock3, cls: "bg-amber-500/10 text-amber-500 border-amber-500/40" },
  info_provided: { label: "Information Provided", short: "Info", Icon: Shield, cls: "bg-sky-500/10 text-sky-400 border-sky-500/40" },
  unverified: { label: "Unverified", short: "Unverified", Icon: ShieldAlert, cls: "bg-slate-500/10 text-slate-400 border-slate-500/40" },
};

export function TrustBadge({ level = "unverified", size = "sm" }) {
  const m = MAP[level] || MAP.unverified;
  const padding = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-3 py-1 text-xs";
  return (
    <span
      data-testid={`trust-badge-${level}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium tracking-wide shrink-0 whitespace-nowrap ${padding} ${m.cls}`}
      title={m.label}
      aria-label={m.label}
    >
      <m.Icon size={13} />
      <span className="hidden sm:inline">{m.label}</span>
      <span className="sm:hidden">{m.short}</span>
    </span>
  );
}
